import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function usePinWelder() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => {
    await api.togglePinned(id);
    queryClient.invalidateQueries(queryKeys.welder.list());
  });
}
